import { createContext } from "react";

import type { PermissionOrWildcard } from "@/features/rbac/permissions/catalog";
import type { RbacRole } from "@/features/rbac/schemas/rbac";
import type { RbacSubject } from "@/features/rbac/services/subjectResolver";
import type { PermissionSource } from "@/features/rbac/utils/resolvePermissions";

export interface RbacContextValue {
  /** ¿Concede el permiso? Mientras carga devuelve `false` (fail closed). */
  can: (permission: PermissionOrWildcard) => boolean;
  /** ¿Concede al menos uno de los permisos? */
  canAny: (permissions: readonly PermissionOrWildcard[]) => boolean;
  /** ¿Concede todos los permisos? */
  canAll: (permissions: readonly PermissionOrWildcard[]) => boolean;
  /** Permisos y comodines efectivos, sin expandir. */
  permissions: ReadonlySet<string>;
  /** Roles que se aplicaron realmente. */
  roleIds: readonly string[];
  /** Definición completa de esos roles. */
  roles: readonly RbacRole[];
  /** De dónde salieron los permisos: asignación explícita o compatibilidad. */
  source: PermissionSource;
  /** Perfil de la persona autenticada. */
  subject: RbacSubject | null;
  /** Verdadero hasta que perfil, roles y asignación están resueltos. */
  isLoading: boolean;
}

export const RbacContext = createContext<RbacContextValue | undefined>(undefined);
